import Hero from './components/Hero'
import Products from './components/Products'
import Model3DViewer from './components/Model3DViewer'
import Services from './components/Services'
import About from './components/About'
import Contact from './components/Contact'
import Footer from './components/Footer'
import './styles/index.css'
import './styles/App.css'

function App() {
  return (
    <div className="app">
      <Hero />
      <Products />
      <Model3DViewer />
      <Services />
      <About />
      <Contact />
      <Footer />
    </div>
  )
}

export default App
